
import {
  getJobs
} from '../api/jobs'
import {
  getConnectors,
  refreshToken,
} from '../api/global'

let jobs;

async function checkJobsLoaded() {
  if (!jobs) jobs = await getJobs()
}


export async function Jobs() {
  await checkJobsLoaded();
  return jobs;
}

export async function JobsList(sortByName = false) {
  await checkJobsLoaded();
  const list =  jobs.map((j) => {
    return { value: j.job_id, text: j.job_name } 
  });
  
  if (sortByName){
    return list.sort((a,b)=> a.text.toUpperCase().localeCompare(b.text.toUpperCase()))
  }
  return list;
}
export async function Connectors(filter){
  const result = await getConnectors();
  if (result)
    return result.filter(c=> c.cnt_name.toLocaleUpperCase().includes(filter.toLocaleUpperCase())
      ).map(c=> {
        return { id: c.cnt_id, name: c.cnt_name, model: c.cnt_model, enable: c.cnt_is_enable };
      }).sort((a,b) => a.id-b.id);
  return null;
}

export async function Refresh(){
  const result = await refreshToken()
  return result;
}